import styles from './StatusPill.module.scss';

type Props = {
  text: string;
  color: string;
  size?: 'small' | 'normal' | 'large';
  border?: boolean;
};

const StatusPill = ({ text, color, size = 'normal', border = true }: Props) => {
  const classes = `${styles.button} ${styles[color]} ${styles[size]} ${
    border ? styles['with-border'] : ''
  }`;

  return <div className={classes}>{text}</div>;
};

export default StatusPill;
